import { post, put, get, deleteReq } from './api';
import { page_size } from '../consts';

export const fetchPresentations = () =>
  get(`/presentations?page_size=${page_size}`);
export const searchPresentations = ({ query }) =>
  get(`/presentations?query=${query}`);

export const createPresentation = presentation =>
  post(`/presentations`, JSON.stringify(presentation), {
    'Content-Type': 'application/json',
  });

export const editPresentation = ({ presentation }) =>
  put(`/presentations/${presentation.id}`, JSON.stringify({ presentation }), {
    'Content-Type': 'application/json',
  });

export const deletePresentation = ({ id }) =>
  deleteReq(`/presentations/${id}`, {
    'Content-Type': 'application/json',
  });

export const removeExtensionFromPresentation = ({ id, extensionId }) =>
  deleteReq(`/presentations/${id}/extensions/${extensionId}`, {
    'Content-Type': 'application/json',
  });

export const fetchPresentation = ({ id }) => get(`/presentations/${id}`);

export const fetchPresentationShares = ({ id }) =>
  get(`/admin/presentations/${id}/shares`);

export const deletePresentationShare = ({ shareId, presentationId }) =>
  deleteReq(`/admin/presentations/${presentationId}/shares/${shareId}`);

export const fetchSharedPresentation = ({ token }) =>
  get(`/users/shared/presentation?token=${token}`);

export const addExtensionToPresentation = ({ id, extensions }) =>
  post(`/presentations/${id}/extensions`, JSON.stringify({ extensions }), {
    'Content-Type': 'application/json',
  });

export const favouriteShare = ({ id, token, favourite }) =>
  put(
    `/users/shared/favourites/${id}?token=${token}`,
    JSON.stringify({ favourite }),
    {
      'Content-Type': 'application/json',
    }
  );



// WEBPACK FOOTER //
// ./src/services/presentationApi.js